import type {PluralFormsModel} from '@/types/aem/pluralFormsModel';
import dateTimeUtils from '@/utils/dateTimeUtils';
import stringUtils from '@/utils/stringUtils';

const DEFAULT_FORMAT_SAME_MONTH = '{0} - {1} {2}, {3}';
const DEFAULT_FORMAT_CROSS_MONTH = '{0} {1} - {2} {3}, {4}';
const DEFAULT_FORMAT_CROSS_YEAR = '{0} {1}, {2} - {3} {4}, {5}';

type GetRescheduleDateLabelParams = {
    minDate: Date;
    maxDate: Date;
    languageCode: string;
    dateDayPluralForms?: PluralFormsModel;
    nextDeliveryDateFormatSameMonth?: string;
    nextDeliveryDateFormatCrossMonth?: string;
    nextDeliveryDateFormatCrossYear?: string;
};

export const getRescheduleDateLabel = ({
    minDate,
    maxDate,
    languageCode,
    dateDayPluralForms,
    nextDeliveryDateFormatSameMonth,
    nextDeliveryDateFormatCrossMonth,
    nextDeliveryDateFormatCrossYear,
}: GetRescheduleDateLabelParams): string => {
    const isSameYear = minDate.getFullYear() === maxDate.getFullYear();
    const isSameMonth = minDate.getMonth() === maxDate.getMonth();
    const minDay = dateTimeUtils.getOrdinalDay(minDate.getDate(), dateDayPluralForms, languageCode);
    const maxDay = dateTimeUtils.getOrdinalDay(maxDate.getDate(), dateDayPluralForms, languageCode);
    const minMonth = dateTimeUtils.getMonth(minDate, languageCode);
    const maxMonth = dateTimeUtils.getMonth(maxDate, languageCode);
    const minYear = String(minDate.getFullYear());
    const maxYear = String(maxDate.getFullYear());

    if (isSameYear && isSameMonth) {
        return stringUtils.formatString(
            nextDeliveryDateFormatSameMonth || DEFAULT_FORMAT_SAME_MONTH,
            minDay,
            maxDay,
            minMonth,
            minYear
        );
    }

    if (isSameYear) {
        return stringUtils.formatString(
            nextDeliveryDateFormatCrossMonth || DEFAULT_FORMAT_CROSS_MONTH,
            minDay,
            minMonth,
            maxDay,
            maxMonth,
            minYear
        );
    }

    return stringUtils.formatString(
        nextDeliveryDateFormatCrossYear || DEFAULT_FORMAT_CROSS_YEAR,
        minDay,
        minMonth,
        minYear,
        maxDay,
        maxMonth,
        maxYear
    );
};
